import React from 'react';
import ActionIconButton from './ActionIconButton';

const AvailabilityButton = ({title = 'Disponibilidade', ...props}) => (
    <ActionIconButton variant="availability" title={title} {...props}/>
);

export default AvailabilityButton;
